module.exports = __webpack_public_path__ + "static/media/right-arrow.35bbe673.png";